<template>
  <div>
    <button type="button" @click="planilhaFranquia()" class="btn btn-primary" v-if="controlerBtnSubmit == true">
      Relatório Franquias (Excel)
    </button>
    <button type="button" class="btn btn-primary" disabled v-else>
      <i class="fa fa-refresh fa-spin"></i> Carregando Relatório de Franquias...
    </button>
  </div>
</template>

<script>
import periodoFranquias from '../../modal/PeriodoFranquias.vue'

export default {
  components: {
    'modal-periodo-franquias': periodoFranquias
  },
  data() {
    return {
      env: process.env,
      controlerBtnSubmit: true,
    };
  },
  methods: {
    planilhaFranquia() {
      let vm = this;
      vm.controlerBtnSubmit = false
      vm.$axios.get(`${vm.env.FINANCEIRO.SLA}/export-franquia`, {
        headers: {
          Authorization: `Bearer ${vm.$store.state.login.loginUsuario.token}`,
        },
        responseType: 'arraybuffer' // às vezes "blob" quebra, use arraybuffer
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "franquias.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        vm.controlerBtnSubmit = true
      })
      .finally(() => {
        vm.controlerBtnSubmit = true; // sempre volta o botão
      });
    }
  },
}
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// ExportFranquiaDinamica.vue?89dbfa72